<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
    
  },
  mounted() {
    // var html = document.querySelector('html');
    //  var rem = html.offsetWidth / 3.75;
    //  if(html.offsetWidth>750){
    //     rem = 750 / 3.75;
    //  }
    //  html.style.fontSize = rem + "px";
  },
}
</script>

<style>
    html,
    body {
      padding: 0;
      margin: 0;
    }
</style>
